module.exports = __webpack_public_path__ + "static/media/10.84aa832b.webp";